import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from "./components/Header";
import DownArrow from "./components/DownArrow";
import About from "./components/About";
import Projects from './components/Projects';
import './index.css';

function App() {
  const [showCopyPopup, setShowCopyPopup] = useState(false);

  // Fix viewport height on mobile
  useEffect(() => {
    // Function to update viewport height
    const updateViewportHeight = () => {
      // Get the actual viewport height and convert it to a CSS custom property
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Update on mount and resize
    updateViewportHeight();
    window.addEventListener('resize', updateViewportHeight);
    window.addEventListener('orientationchange', updateViewportHeight);

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateViewportHeight);
      window.removeEventListener('orientationchange', updateViewportHeight);
    };
  }, []);

  const handleEmailClick = () => {
    const email = 'charles.e.keely@gmail.com';
    navigator.clipboard.writeText(email).then(() => {
      setShowCopyPopup(true);
      setTimeout(() => setShowCopyPopup(false), 2000); // Hide after 2 seconds
    });
  };

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          {/* Home page with full layout */}
          <Route path="/" element={
            <main>
              <div className="app-container">
                <section className="home-hero">
                  <div className="top-section">
                    <div className="right-section">
                      <img
                        src="/images/profile1.jpg"
                        alt="Profile"
                        className="profile-image"
                      />
                      <h3 className="charles-keely">CHARLES KEELY</h3>
                      <h5 className="job-titles">Solutions Engineer, Full-Stack Developer, Creative Technologist</h5>
                      <div className="namecard">
                        <h5 className="job-title-dashes">—</h5>
                        <h6>BS in Creative Technologies and Design</h6>
                        <h6>with a Minor in Computer Science</h6>
                        <h6>from</h6>
                        <h6>The University of Colorado Boulder</h6>
                        <h6>School of Engineering</h6>
                        <h5 className="job-title-dashes">—</h5>
                      </div>
                      <div className="contact" onClick={handleEmailClick}>
                        <img src="/images/email-icon.png" alt="email icon" className="clickable" />
                        <h6 className='email clickable'>charles.e.keely@gmail.com</h6>
                        <div className={`copy-popup ${showCopyPopup ? 'show' : ''}`}>
                          Copied to clipboard!
                        </div>
                      </div>
                    </div>
                    <About />
                  </div>
                  <DownArrow />
                </section>
                <Projects />
              </div>
            </main>
          } />

          {/* Category pages with filtered projects */}
          <Route path="/software" element={<Projects category="Software" />} />
          <Route path="/physical-computing" element={<Projects category="Physical Computing" />} />
          <Route path="/installations" element={<Projects category="Installations" />} />
          <Route path="/music" element={<Projects category="Music" />} />
          <Route path="/video" element={<Projects category="Video" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;